import { render, staticRenderFns } from "./EditionModal.vue?vue&type=template&id=4325baba&scoped=true"
import script from "./EditionModal.vue?vue&type=script&lang=js"
export * from "./EditionModal.vue?vue&type=script&lang=js"
import style0 from "./EditionModal.vue?vue&type=style&index=0&id=4325baba&prod&scoped=true&lang=scss"
import style1 from "./EditionModal.vue?vue&type=style&index=1&id=4325baba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325baba",
  null
  
)

export default component.exports